

import Button from '../../../components/base/Button';

export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-[#F0F0F0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-black mb-6">
              Meet Our <span className="text-[#8A4F8A]">Clinical Director</span>
            </h2>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-[#C8A2C8] to-[#8A4F8A] rounded-full flex items-center justify-center mr-6">
                  <i className="ri-user-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-black">Deborah Okonofua, CRNP</h3>
                  <p className="text-[#8A4F8A] font-semibold">Clinical Director & Nurse Practitioner</p>
                </div>
              </div>
              
              <div className="space-y-4 text-black">
                <p className="flex items-start">
                  <i className="ri-check-double-line text-[#8A4F8A] mr-3 mt-1"></i>
                  <span><strong>20+ years of experience</strong> in Family Medicine & Mental Health</span>
                </p>
                <p className="flex items-start">
                  <i className="ri-check-double-line text-[#8A4F8A] mr-3 mt-1"></i>
                  <span><strong>Expert in advanced integrative therapies</strong> including peptide therapy and IV treatments</span>
                </p>
                <p className="flex items-start">
                  <i className="ri-check-double-line text-[#8A4F8A] mr-3 mt-1"></i>
                  <span><strong>Passionate about patient care</strong> and long-term health transformation</span>
                </p>
                <p className="flex items-start">
                  <i className="ri-check-double-line text-[#8A4F8A] mr-3 mt-1"></i>
                  <span><strong>Specialized in mental health</strong> and holistic wellness approaches</span>
                </p>
              </div>
              
              <div className="mt-6 p-4 bg-gradient-to-r from-[#F0F0F0] to-[#D0D0D0] rounded-lg">
                <p className="text-black italic">
                  "My mission is to help patients achieve optimal health through personalized, science-based treatments that address the root causes of health challenges, not just symptoms."
                </p>
              </div>
            </div>
          </div>
          
          <div className="space-y-6">
            <img 
              src="https://static.readdy.ai/image/a10f8604063c6fe0566ec3f4e3cab275/eb4cb4546669d93ebc481654e9078eaa.png"
              alt="Deborah Okonofua, CRNP"
              className="w-full rounded-xl shadow-lg object-cover object-top"
            />
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <h4 className="text-xl font-bold text-black mb-4">Our Commitment to Excellence</h4>
              <ul className="space-y-3">
                <li className="flex items-center text-black">
                  <i className="ri-medal-line text-[#8A4F8A] mr-3"></i>
                  Board-certified medical professionals
                </li>
                <li className="flex items-center text-black">
                  <i className="ri-heart-pulse-line text-[#8A4F8A] mr-3"></i>
                  Comprehensive health assessments
                </li>
                <li className="flex items-center text-black">
                  <i className="ri-microscope-line text-[#8A4F8A] mr-3"></i>
                  Evidence-based treatment protocols
                </li>
                <li className="flex items-center text-black">
                  <i className="ri-customer-service-line text-[#8A4F8A] mr-3"></i>
                  Ongoing patient support and monitoring
                </li>
              </ul>
              
              <Button className="w-full mt-6">
                <i className="ri-calendar-line mr-2"></i>
                Schedule a Consultation
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

